import { ServerConfig } from '../types';

const HOUR = 60 * 60;
const DAY = 24 * HOUR;

// Offered lifetimes, as far as the server allows them
export const RETENTION_PRESETS = [HOUR, DAY, 7 * DAY];

// Used until /api/config answers, and if it fails; matches the server defaults
export const FALLBACK_CONFIG: ServerConfig = {
  minExpiresIn: 60,
  maxExpiresIn: 7 * DAY,
  defaultExpiresIn: DAY,
  defaultOneTime: false,
};

/**
 * Presets within the server's range, plus the server default if it is no preset.
 * Never empty: with a maximum below every preset, the maximum is offered.
 */
export const retentionChoices = (config: ServerConfig): number[] => {
  const choices = RETENTION_PRESETS.filter(s => s >= config.minExpiresIn && s <= config.maxExpiresIn);
  if (!choices.includes(config.defaultExpiresIn)) choices.push(config.defaultExpiresIn);
  return choices.sort((a, b) => a - b);
};

const plural = (n: number, one: string, many: string) => `${n} ${n === 1 ? one : many}`;

export const formatDuration = (seconds: number): string => {
  if (seconds % DAY === 0) return plural(seconds / DAY, 'Tag', 'Tage');
  if (seconds % HOUR === 0) return plural(seconds / HOUR, 'Stunde', 'Stunden');
  return plural(Math.round(seconds / 60), 'Minute', 'Minuten');
};

export const formatExpiry = (iso: string): string =>
  new Date(iso).toLocaleString('de-DE', { dateStyle: 'medium', timeStyle: 'short' });
